import { useLayoutEffect, useState } from "react";

// material-ui
import { useTheme } from "@mui/material/styles";
import { Box, Typography, useMediaQuery } from "@mui/material";

// project-imports
import NavGroup from "./NavGroup";
import menuItem from "menu-items";
// import { Menu } from 'menu-items/dashboard';

import { useSelector } from "store";
import useConfig from "hooks/useConfig";
import { HORIZONTAL_MAX_ITEM } from "config";

// types
import { NavItemType } from "types/menu";
import { MenuOrientation } from "types/config";
import useAuth from "hooks/useAuth";
import { fetchProductList } from "utils/getProductData";
import { FormattedMessage } from "react-intl";
import { ShoppingBag } from "iconsax-react";
import { encryptIDValues } from "helpers/commonHelpers";

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

const Navigation = () => {
  const theme = useTheme();
  const { user } = useAuth();
  const userType = user?.user_type ? parseInt(user.user_type) : undefined;

  const downLG = useMediaQuery(theme.breakpoints.down("lg"));

  const { menuOrientation } = useConfig();
  const { drawerOpen } = useSelector((state) => state.menu);

  const [selectedItems, setSelectedItems] = useState<string | undefined>("");
  const [selectedLevel, setSelectedLevel] = useState<number>(0);
  const [menuItems, setMenuItems] = useState<{ items: NavItemType[] }>({
    items: [],
  });
  const [productMenu, setProductMenu] = useState<NavItemType>({});

  const icons = {
    product: ShoppingBag,
  };

  fetchProductList()
    .then((productList: any) => {
      const productMenuItems = productList.map((product: any) => ({
        id: product.value,
        title: product.label,
        type: "item",
        url: `/products-detail/${encryptIDValues(product.value)}`,
        icon: icons.product,
      }));
      const product: NavItemType = {
        id: "group-product",
        title: <FormattedMessage id="Products" />,
        icon: icons.product,
        type: "group",
        children: productMenuItems,
        breadcrumbs: false,
      };
      setProductMenu(product);
    })
    .catch((error) => {
      console.error(error);
    });

  // useEffect(() => {
  //   handlerMenuItem();
  // }, []);

  useLayoutEffect(() => {
    const updatedMenuItem = {
      ...menuItem,
      items: [...menuItem.items, productMenu],
    };

    // Filter menuItem based on userType
    const filteredMenuItems = updatedMenuItem.items.filter((item) => {
      // Modify this condition according to your requirement
      if (userType === 1) {
        // Example condition: Return true if userType is 1
        return (
          item.id !== "group-transactions" && item.id !== "group-cloudviewuser"
        );
      } else if (userType === 2) {
        // Example condition: Return true if userType is 2
        return (
          item.id !== "group-master" &&
          item.id !== "group-cloudview" &&
          item.id !== "group-finance" &&
          item.id !== "group-traffic" &&
          item.id !== "group-cloudviewuser"
        );
      } else if (userType === 3) {
        // Example condition: Return true if userType is 3
        return (
          item.id !== "group-master" &&
          item.id !== "group-cloudview" &&
          item.id !== "group-finance" &&
          item.id !== "group-traffic" &&
          item.id !== "group-cloudviewuser"
        );
      } else if (userType === 4) {
        // Example condition: Return true if userType is 4
        return (
          item.id !== "group-master" &&
          item.id !== "group-cloudview" &&
          item.id !== "group-finance" &&
          item.id !== "group-traffic" &&
          item.id !== "group-cloudviewuser"
        );
      } else if (userType === 5) {
        // Example condition: Return true if userType is 5
        return (
          item.id !== "group-master" &&
          item.id !== "group-users" &&
          item.id !== "group-cloudview" &&
          item.id !== "group-users-list" &&
          item.id !== "group-finance" &&
          item.id !== "group-traffic" &&
          item.id !== "group-cloudviewuser"
        );
      } else if (userType === 6) {
        // Example condition: Return true if userType is 5
        return (
          item.id !== "group-master" &&
          item.id !== "group-users" &&
          item.id !== "group-cloudview" &&
          item.id !== "group-users-list" &&
          item.id !== "group-finance" &&
          item.id !== "group-product" &&
          item.id !== "group-transactions" &&
          item.id !== "group-applications" &&
          item.id !== "group-traffic" &&
          item.id !== "group-support"
        );
      }
      // Add more conditions as needed for different userTypes
      return false;
    });

    // Update the state with filtered menuItems
    setMenuItems({ items: filteredMenuItems });
    // eslint-disable-next-line
  }, [menuItem, productMenu]);

  // let getMenu = Menu();
  // const handlerMenuItem = () => {
  //   const isFound = menuItem.items.some((element) => {
  //     if (element.id === 'group-dashboard') {
  //       return true;
  //     }
  //     return false;
  //   });

  //   if (getMenu?.id !== undefined && !isFound) {
  //     menuItem.items.splice(0, 0, getMenu);
  //     setMenuItems(menuItem);
  //   }
  // };

  const isHorizontal =
    menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

  const lastItem = isHorizontal ? HORIZONTAL_MAX_ITEM : null;
  let lastItemIndex = menuItems.items.length - 1;
  let remItems: NavItemType[] = [];
  let lastItemId: string;

  if (lastItem && lastItem < menuItems.items.length) {
    lastItemId = menuItems.items[lastItem - 1].id!;
    lastItemIndex = lastItem - 1;
    remItems = menuItems.items
      .slice(lastItem - 1, menuItems.items.length)
      .map((item) => ({
        title: item.title,
        elements: item.children,
        icon: item.icon,
      }));
  }

  const navGroups = menuItems.items.slice(0, lastItemIndex + 1).map((item) => {
    switch (item.type) {
      case "group":
        return (
          <NavGroup
            key={item.id}
            setSelectedItems={setSelectedItems}
            setSelectedLevel={setSelectedLevel}
            selectedLevel={selectedLevel}
            selectedItems={selectedItems}
            lastItem={lastItem!}
            remItems={remItems}
            lastItemId={lastItemId}
            item={item}
          />
        );
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });
  return (
    <Box
      sx={{
        pt: drawerOpen ? (isHorizontal ? 0 : 2) : 0,
        "& > ul:first-of-type": { mt: 0 },
        display: isHorizontal ? { xs: "block", lg: "flex" } : "block",
      }}
    >
      {navGroups}
    </Box>
  );
};

export default Navigation;
